export default {"src":"/_next/static/media/btn_googleplay1.63f82cba.svg","height":50,"width":140,"blurWidth":0,"blurHeight":0};